import { Routes, Route } from "react-router-dom";
import MainContainer from "./layout/MainContainer";
import Pages from "./pages";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Dashboard />} />
        <Route path="/manage-users" element={<Pages.ManageUser />} />
        <Route path="/manage-users/detail" element={<Pages.ManageUserDetail />} />
        <Route path="/manage-users/edit" element={<Pages.Edituser />} />
        <Route path="/manage-users/add" element={<Pages.Edituser />} />
        <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
        <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
        <Route path="/manage-subadmin/detail" element={<Pages.SubadminDetail />} />
        <Route path="/manage-subadmin/roles" element={<Pages.ManageSubadminRoles />} />
        <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
        <Route path="/manage-subadmin/roles/detail" element={<Pages.RoleDetail />} />
        <Route path="/manage-notifications" element={<Pages.ManageNotifications />} />
        <Route path="/manage-notifications/add" element={<Pages.AddNotification />} />
        <Route path="/manage-notifications/detail" element={<Pages.NotificationDetail />} />
        <Route path="/recieved-notifications" element={<Pages.RecievedNotifications />} />
        <Route path="/manage-cms" element={<Pages.ManageCms />} />
        <Route path="/manage-profile" element={<Pages.ManageProfile />} />
        <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
        <Route path="/manage-profile/change-password" element={<Pages.ChangePassword />} />
        <Route path="/manage-analytics" element={<Pages.ManageAnalytics />} />
        <Route path="/manage-categories" element={<Pages.ManageCategories />} />
        <Route path="/manage-categories/sub-categories" element={<Pages.ManageSubCategories />} />
        <Route path="/manage-brands" element={<Pages.ManageBrands />} />
        <Route path="/manage-brands/detail" element={<Pages.BrandDetail />} />
        <Route path="/manage-fuel-type" element={<Pages.ManageFuelType />} />
        <Route path="/manage-engine-power" element={<Pages.ManageEnginePower />} />
        <Route path="/manage-transmission" element={<Pages.ManageTransmission />} />
        <Route path="/manage-drive-type" element={<Pages.ManageDriveType />} />
        <Route path="/manage-emissions-class" element={<Pages.ManageEmissionsClass />} />
        <Route path="/manage-environmental-badge" element={<Pages.ManageEnvironmentalBadge />} />
        <Route path="/manage-vehicle-type" element={<Pages.ManageVehicleType />} />
        <Route path="/manage-damage-type" element={<Pages.ManageDamageType />} />
        <Route path="/manage-color" element={<Pages.ManageColor />} />
        <Route path="/manage-model" element={<Pages.ManageModel />} />
        <Route path="/manage-axles" element={<Pages.ManageAxles />} />
        <Route path="/manage-condition" element={<Pages.ManageCondition />} />
        <Route path="/manage-dealers" element={<Pages.ManageDealers />} />
        <Route path="/manage-dealers/add" element={<Pages.AddEditDealer />} />
        <Route path="/manage-dealers/edit" element={<Pages.AddEditDealer />} />
        <Route path="/manage-dealers/detail" element={<Pages.ManageDealersDetail />} />
        <Route path="/manage-packages" element={<Pages.ManagePackages />} />
        <Route path="/manage-packages/add" element={<Pages.AddEditPackage />} />
        <Route path="/manage-packages/edit" element={<Pages.AddEditPackage />} />
        <Route path="/manage-packages/detail" element={<Pages.PackageDetail />} />
        <Route path="/manage-revenue" element={<Pages.ManageRevenue />} />
        <Route path="/manage-vehicles" element={<Pages.ManageVehicles />} />
        <Route path="/manage-vehicles/add" element={<Pages.AddEditVehicle />} />
        <Route path="/manage-vehicles/edit" element={<Pages.AddEditVehicle />} />
        <Route path="/manage-vehicles/detail" element={<Pages.ManageVehicleDetail />} />
        <Route path="/manage-spare-parts" element={<Pages.ManageSpareParts />} />
        <Route path="/manage-spare-parts/add" element={<Pages.AddEditSparePart />} />
        <Route path="/manage-spare-parts/edit" element={<Pages.AddEditSparePart />} />
        <Route path="/manage-spare-parts/detail" element={<Pages.ManageSparePartsDetail />} />
        <Route path="/manage-car-accessories" element={<Pages.ManageCarAccessories />} />
        <Route path="/manage-car-accessories/add" element={<Pages.AddEditCarAccessory />} />
        <Route path="/manage-car-accessories/edit" element={<Pages.AddEditCarAccessory />} />
        <Route path="/manage-car-accessories/detail" element={<Pages.ManageCarAccessoryDetail />} />
        <Route path="/manage-blogs-listings" element={<Pages.ManageBlogs />} />
        <Route path="/manage-blogs-listings/add" element={<Pages.AddEditBlog />} />
        <Route path="/manage-blogs-listings/edit" element={<Pages.AddEditBlog />} />
        <Route path="/manage-blogs-listings/detail" element={<Pages.BlogDetail />} />
        <Route path="/manage-blogs-categories" element={<Pages.ManageBlogCategories />} />
        <Route path="/manage-features" element={<Pages.ManageFeatures />} />
        <Route path="/manage-features/:groupId" element={<Pages.FeatureGroupDetails />} />
      </Route>
    </Routes>
  );
};

export default Routing;
